<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <div class="topBox flex">
      <div class="topLeft flex" style="align-items: center; flex-wrap: wrap">
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">用户昵称：</span>
          <div style="width: 180px">
            <el-input v-model="query.nickName" placeholder="模糊" clearable @keyup.enter.native="searchFn" />
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">真实姓名：</span>
          <div style="width: 140px">
            <el-input v-model="query.realName" placeholder="模糊" clearable @keyup.enter.native="searchFn" />
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">是否实名：</span>
          <div style="width: 160px">
            <el-select v-model="query.realNameVerified" placeholder="全部" clearable @change="searchFn">
              <el-option v-for="o in yesNoOptions" :key="o.value" :label="o.label" :value="o.value" />
            </el-select>
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">是否考试：</span>
          <div style="width: 160px">
            <el-select v-model="query.examPassed" placeholder="全部" clearable @change="searchFn">
              <el-option v-for="o in yesNoOptions" :key="o.value" :label="o.label" :value="o.value" />
            </el-select>
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">是否小法官：</span>
          <div style="width: 160px">
            <el-select v-model="query.enabled" placeholder="全部" clearable @change="searchFn">
              <el-option v-for="o in yesNoOptions" :key="o.value" :label="o.label" :value="o.value" />
            </el-select>
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">小法官等级：</span>
          <div style="width: 180px">
            <el-select v-model="query.level" placeholder="全部" clearable @change="searchFn">
              <el-option v-for="o in levelOptions" :key="String(o.value)" :label="o.label" :value="o.value" />
            </el-select>
          </div>
        </div>

        <el-button type="success" size="small" @click="searchFn">搜索</el-button>
        <el-button size="small" @click="resetFn">重置</el-button>
        <el-button type="primary" size="small" @click="openAddDialog">新增</el-button>
      </div>
    </div>

    <el-table :data="tableData" border style="width: 100%; margin-top: 12px" v-loading="loading">
      <el-table-column prop="id" label="ID" width="90" align="center" />
      <el-table-column label="头像" width="90" align="center">
        <template slot-scope="scope">
          <img
            v-if="scope.row.photo"
            :src="scope.row.photo"
            style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover"
            alt=""
          />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="nickName" label="用户昵称" min-width="140" align="center" show-overflow-tooltip />
      <el-table-column label="等级" width="120" align="center">
        <template slot-scope="scope">{{ levelLabel(scope.row.level) }}</template>
      </el-table-column>
      <el-table-column label="实名" width="90" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.realNameVerified"
            active-value="1"
            inactive-value="0"
            :disabled="isRowUpdating(scope.row, 'realNameVerified')"
            @change="(val) => onToggleStatus(scope.row, 'realNameVerified', val)"
          />
          <span style="margin-left: 6px">{{ ynLabel(scope.row.realNameVerified) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="考试" width="90" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.examPassed"
            active-value="1"
            inactive-value="0"
            :disabled="isRowUpdating(scope.row, 'examPassed')"
            @change="(val) => onToggleStatus(scope.row, 'examPassed', val)"
          />
          <span style="margin-left: 6px">{{ ynLabel(scope.row.examPassed) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="小法官" width="110" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.enabled"
            active-value="1"
            inactive-value="0"
            :disabled="isRowUpdating(scope.row, 'enabled')"
            @change="(val) => onToggleStatus(scope.row, 'enabled', val)"
          />
          <span style="margin-left: 6px">{{ ynLabel(scope.row.enabled) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="220" show-overflow-tooltip />
      <el-table-column prop="verifiedAt" label="实名通过时间" width="170" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.verifiedAt) }}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="170" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="170" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.updateTime) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="120" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="small" type="primary" plain @click="openEditDialog(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="page_box">
      <el-pagination
        @current-change="changePage"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="tableTotal"
      />
    </div>

    <el-dialog title="新增小法官" :visible.sync="addVisible" width="640px" :close-on-click-modal="false" @closed="onAddClosed">
      <div v-loading="addLoading">
        <el-form ref="addFormRef" :model="addForm" :rules="addRules" label-width="120px" size="small">
          <el-form-item label="选择用户" prop="userId">
            <el-select
              v-model="addForm.userId"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="输入昵称搜索并选择"
              :remote-method="searchUserRemote"
              :loading="userSearchLoading"
              style="width: 100%"
            >
              <el-option v-for="u in userOptions" :key="String(u.id)" :label="u.label" :value="u.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="小法官等级" prop="level">
            <el-select v-model="addForm.level" placeholder="请选择" style="width: 100%">
              <el-option label="初级小法官" :value="1" />
              <el-option label="中级小法官" :value="2" />
              <el-option label="高级小法官" :value="3" />
            </el-select>
          </el-form-item>
          <el-form-item label="是否实名" prop="realNameVerified">
            <el-select v-model="addForm.realNameVerified" placeholder="请选择" style="width: 100%">
              <el-option label="否" value="0" />
              <el-option label="是" value="1" />
            </el-select>
          </el-form-item>
          <el-form-item label="是否考试" prop="examPassed">
            <el-select v-model="addForm.examPassed" placeholder="请选择" style="width: 100%">
              <el-option label="否" value="0" />
              <el-option label="是" value="1" />
            </el-select>
          </el-form-item>
          <el-form-item label="是否小法官" prop="enabled">
            <el-select v-model="addForm.enabled" placeholder="请选择" style="width: 100%">
              <el-option label="否" value="0" />
              <el-option label="是" value="1" />
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="addForm.remark" type="textarea" :rows="3" placeholder="可选" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取消</el-button>
        <el-button type="primary" :loading="addSubmitLoading" @click="submitAdd">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑小法官" :visible.sync="editVisible" width="560px" :close-on-click-modal="false" @closed="onEditClosed">
      <div v-loading="editLoading">
        <el-form ref="editFormRef" :model="editForm" :rules="editRules" label-width="120px" size="small">
          <el-form-item label="用户昵称">
            <el-input v-model="editForm.nickName" disabled />
          </el-form-item>
          <el-form-item label="小法官等级" prop="level">
            <el-select v-model="editForm.level" placeholder="请选择" style="width: 100%">
              <el-option label="初级小法官" :value="1" />
              <el-option label="中级小法官" :value="2" />
              <el-option label="高级小法官" :value="3" />
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="editForm.remark" type="textarea" :rows="3" placeholder="可选" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="editSubmitLoading" @click="submitEdit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { returnTime } from "@/util/utils";

export default {
  data() {
    return {
      historyArr: ["小法官列表"],
      loading: false,
      yesNoOptions: [
        { label: "全部", value: null },
        { label: "否", value: "0" },
        { label: "是", value: "1" },
      ],
      levelOptions: [
        { label: "全部", value: null },
        { label: "初级小法官", value: 1 },
        { label: "中级小法官", value: 2 },
        { label: "高级小法官", value: 3 },
      ],
      query: {
        nickName: "",
        realName: "",
        realNameVerified: null,
        examPassed: null,
        enabled: null,
        level: null,
      },
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      tableTotal: 0,

      addVisible: false,
      addLoading: false,
      addSubmitLoading: false,
      userOptions: [],
      userSearchLoading: false,
      _userSearchTimer: null,
      addForm: {
        userId: null,
        level: 1,
        realNameVerified: "0",
        examPassed: "0",
        enabled: "0",
        remark: "",
      },
      addRules: {
        userId: [{ required: true, message: "请选择用户", trigger: "change" }],
        level: [{ required: true, message: "请选择等级", trigger: "change" }],
        realNameVerified: [{ required: true, message: "请选择是否实名", trigger: "change" }],
        examPassed: [{ required: true, message: "请选择是否考试", trigger: "change" }],
        enabled: [{ required: true, message: "请选择是否小法官", trigger: "change" }],
      },

      editVisible: false,
      editLoading: false,
      editSubmitLoading: false,
      editForm: { userId: null, nickName: "", level: 1, remark: "" },
      editRules: {
        level: [{ required: true, message: "请选择等级", trigger: "change" }],
      },
    };
  },

  mounted() {
    this.fetchList(1);
  },

  methods: {
    ynLabel(v) {
      if (v === "1" || v === 1 || v === true) return "是";
      if (v === "0" || v === 0 || v === false) return "否";
      return "-";
    },

    levelLabel(v) {
      if (v === 1) return "初级小法官";
      if (v === 2) return "中级小法官";
      if (v === 3) return "高级小法官";
      return v == null ? "-" : String(v);
    },

    formatTime(t) {
      if (!t) return "-";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },

    resetFn() {
      this.query = { nickName: "", realName: "", realNameVerified: null, examPassed: null, enabled: null, level: null };
      this.currentPage = 1;
      this.fetchList(1);
    },

    searchFn() {
      this.currentPage = 1;
      this.fetchList(1);
    },

    changePage(p) {
      this.fetchList(p);
    },

    openAddDialog() {
      this.addVisible = true;
      this.addLoading = false;
      this.addSubmitLoading = false;
      this.userOptions = [];
      this.userSearchLoading = false;
      this.addForm = {
        userId: null,
        level: 1,
        realNameVerified: "0",
        examPassed: "0",
        enabled: "0",
        remark: "",
      };
      this.$nextTick(() => {
        if (this.$refs.addFormRef) this.$refs.addFormRef.clearValidate();
      });
    },

    onAddClosed() {
      this.addLoading = false;
      this.addSubmitLoading = false;
      this.userOptions = [];
      this.userSearchLoading = false;
      if (this._userSearchTimer) {
        clearTimeout(this._userSearchTimer);
        this._userSearchTimer = null;
      }
      this.$nextTick(() => {
        if (this.$refs.addFormRef) this.$refs.addFormRef.clearValidate();
      });
    },

    searchUserRemote(query) {
      const q = String(query || "").trim();
      if (this._userSearchTimer) {
        clearTimeout(this._userSearchTimer);
        this._userSearchTimer = null;
      }
      if (!q) {
        this.userOptions = [];
        return;
      }
      this._userSearchTimer = setTimeout(() => {
        this.userSearchLoading = true;
        const obj = { page: 1, size: 20, nickName: q };
        this.$https(this.$api.api.selUser, obj, "POST")
          .then((res) => {
            if (res.data && res.data.code == 200) {
              const list = res.data.data || [];
              this.userOptions = list
                .filter((x) => x && x.id != null)
                .map((x) => {
                  const name = x.nickName != null ? String(x.nickName) : "";
                  const scentId = x.scentId != null ? String(x.scentId) : "";
                  const base = name ? name : "未知用户";
                  const label = scentId ? `${base}（香味ID：${scentId}）` : base;
                  return { id: x.id, label: label };
                });
            } else {
              this.userOptions = [];
            }
          })
          .finally(() => {
            this.userSearchLoading = false;
          });
      }, 250);
    },

    submitAdd() {
      if (!this.$refs.addFormRef) return;
      this.$refs.addFormRef.validate((valid) => {
        if (!valid) return;
        const n = Number(this.addForm.userId);
        if (this.addForm.userId == null || Number.isNaN(n)) return;
        const payload = {
          userId: n,
          level: this.addForm.level,
          realNameVerified: this.addForm.realNameVerified,
          examPassed: this.addForm.examPassed,
          enabled: this.addForm.enabled,
          remark: this.addForm.remark,
        };
        this.addSubmitLoading = true;
        this.$https(this.$api.api.addSecondhandJuror, payload, "POST")
          .then((res) => {
            if (res.data && res.data.code == 200) {
              this.$message.success("新增成功");
              this.addVisible = false;
              this.fetchList(1);
              this.currentPage = 1;
            } else {
              this.$message.error((res.data && res.data.msg) || "新增失败");
            }
          })
          .finally(() => {
            this.addSubmitLoading = false;
          });
      });
    },

    openEditDialog(row) {
      if (!row || row.userId == null) return;
      this.editVisible = true;
      this.editLoading = false;
      this.editSubmitLoading = false;
      this.editForm = {
        userId: row.userId,
        nickName: row.nickName || "",
        level: row.level != null ? row.level : 1,
        remark: row.remark != null ? String(row.remark) : "",
      };
      this.$nextTick(() => {
        if (this.$refs.editFormRef) this.$refs.editFormRef.clearValidate();
      });
    },

    onEditClosed() {
      this.editLoading = false;
      this.editSubmitLoading = false;
      this.$nextTick(() => {
        if (this.$refs.editFormRef) this.$refs.editFormRef.clearValidate();
      });
    },

    submitEdit() {
      if (!this.$refs.editFormRef) return;
      this.$refs.editFormRef.validate((valid) => {
        if (!valid) return;
        if (this.editForm.userId == null) return;
        const payload = {
          userId: this.editForm.userId,
          level: this.editForm.level,
          remark: this.editForm.remark,
        };
        this.editSubmitLoading = true;
        this.$https(this.$api.api.updateSecondhandJuror, payload, "POST")
          .then((res) => {
            if (res.data && res.data.code == 200) {
              this.$message.success("保存成功");
              this.editVisible = false;
              this.fetchList(this.currentPage);
            } else {
              this.$message.error((res.data && res.data.msg) || "保存失败");
            }
          })
          .finally(() => {
            this.editSubmitLoading = false;
          });
      });
    },

    isRowUpdating(row, field) {
      if (!row) return false;
      const m = row.__updating || {};
      return !!m[field];
    },

    onToggleStatus(row, field, val) {
      if (!row || row.userId == null) return;
      const v = val != null ? String(val) : "0";
      const prev = v === "1" ? "0" : "1";

      if (!row.__updating) this.$set(row, "__updating", {});
      this.$set(row.__updating, field, true);

      const payload = { userId: row.userId };
      payload[field] = v;

      this.$https(this.$api.api.updateSecondhandJuror, payload, "POST")
        .then((res) => {
          if (!(res.data && res.data.code == 200)) {
            this.$message.error((res.data && res.data.msg) || "保存失败");
            this.$set(row, field, prev);
          }
        })
        .catch(() => {
          this.$message.error("保存失败");
          this.$set(row, field, prev);
        })
        .finally(() => {
          this.$set(row.__updating, field, false);
        });
    },

    fetchList(page) {
      this.loading = true;
      const obj = { page: page || 1, size: this.pageSize };
      const nn = String(this.query.nickName || "").trim();
      if (nn) obj.nickName = nn;
      const rn = String(this.query.realName || "").trim();
      if (rn) obj.realName = rn;
      if (this.query.realNameVerified != null) obj.realNameVerified = this.query.realNameVerified;
      if (this.query.examPassed != null) obj.examPassed = this.query.examPassed;
      if (this.query.enabled != null) obj.enabled = this.query.enabled;
      if (this.query.level != null) obj.level = this.query.level;

      this.$https(this.$api.api.selSecondhandJuror, obj, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.tableData = res.data.data || [];
            this.tableTotal = res.data.size || 0;
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error((res.data && res.data.msg) || "查询失败");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
#box {
  width: 100%;
  .topBox {
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
  }
  .topLeft {
    align-items: center;
  }
  .page_box {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/secondhandJuror/index.vue